import { chatIcons } from '../assets/chatIcons';
import { ITextChatMessage } from '../model/ITextChatMessage';
import { uiState } from '../state';
import { isFinalMessage } from './helpers/buildMsgIncommingLoader';

export function buildCommandsBlock(msg, textChatOptions) {
    const isBlockVisible = msg.ctx?.enableFeedback || textChatOptions?.bubbles?.response?.copyBtn;
    
    return `<div class="alan-btn__chat-response-commands-wrapper ${isBlockVisible !== true ? 'alan-btn__chat-response-commands-wrapper-hidden' : ''}">
        <div class="alan-btn__chat-response-commands-wrapper-content">
        ${buildCopyBtnContent(msg)}
        ${msg.ctx?.enableFeedback ? `
        <span class="alan-btn__chat-response__like-btn ${msg.liked >= 1 ? 'selected' : ''}">${getLikeSvgIcon(msg)}</span>
        <span class="alan-btn__chat-response__dislike-btn ${msg.liked <= -1 ? 'selected' : ''}">${getDislikeSvgIcon(msg)}</span>` : ''}
        </div></div>`;
}

export function getLikeSvgIcon(msg) {
    return msg.liked === 1 ? chatIcons.likeSelected : chatIcons.like;
}

export function getDislikeSvgIcon(msg) {
    return msg.liked === -1 ? chatIcons.dislikeSelected : chatIcons.dislike;
}

function buildCopyBtnContent(msg) {
    const copyBtn = `<div class = "alan-btn__chat-response__copy-btn">${chatIcons.copy}${chatIcons.copied}</div>`;
    if (msg.initLoad) return copyBtn;
    return (msg.type === 'response' && isFinalMessage(msg)) ? copyBtn : '';
}

export function changeMsgLikeStatus(msg: ITextChatMessage) {
    const reqId = msg.ctx?.reqId || msg.reqId;
    if (reqId) {
        window.tutorProject.call('sendFeedback', { reqId, status: msg.liked });
    }
}

export function resetStylesForLikeAndDislikeBtns(curMsgBubble, msg) {
    const likeBtnEl = curMsgBubble.querySelector('.alan-btn__chat-response__like-btn');
    const dislikeBtnEl = curMsgBubble.querySelector('.alan-btn__chat-response__dislike-btn');
    if (likeBtnEl && dislikeBtnEl) {
        likeBtnEl.innerHTML = getLikeSvgIcon(msg);
        dislikeBtnEl.innerHTML = getDislikeSvgIcon(msg);
    }
}


export function deleteHiddenImagesWithCode(str) {
    return (str || '').replace(/<img\s+style="display:none;".*?\/>/gi, '').replace(/\s+$/g, '');
}
